import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import clsx from 'clsx';
import React from 'react';
import { ConsumerRightsByStateI } from './ComsumerRightsByState';

interface StateRightsCardProps {
	consumerRightsByState: ConsumerRightsByStateI;
}

const StateRightsCard: React.FC<StateRightsCardProps> = ({
	consumerRightsByState,
}) => {
	const [isOpen, setIsOpen] = React.useState(false);

	return (
		<div className="py-6 border-b border-gray-disabled">
			<div
				className={clsx('w-full flex items-center justify-between ', {
					'mb-6': isOpen,
				})}
			>
				<Typography type="semibold-16">
					{consumerRightsByState.state}{' '}
					{consumerRightsByState.effectiveDate && (
						<span className="font-normal">
							{consumerRightsByState.effectiveDate}
						</span>
					)}
				</Typography>
				<div
					onClick={() => setIsOpen((pre) => !pre)}
					className="cursor-pointer"
				>
					<Icon
						src={Icons.arrowDown}
						className={clsx('w-6 h-6', { 'rotate-180': isOpen })}
						width={24}
						height={24}
					/>
				</div>
			</div>
			{isOpen && (
				<div>
					<Typography type="semibold-16">Customer Rights</Typography>
					<br />
					<ul className="list-disc ml-6 my-0">
						{consumerRightsByState.rights.map((item, index) => (
							<li className="" key={index}>
								<Typography type="regular-16">
									<span className="font-semibold">{item.highlightText}</span>{' '}
									{item.info}
								</Typography>
							</li>
						))}
					</ul>
				</div>
			)}
		</div>
	);
};

export default StateRightsCard;
